import React from 'react'

import Base from '../_Base'

const ChevronDown = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <polygon
      transform="translate(12.000000, 12.300000) rotate(90.000000) translate(-12.000000, -12.300000) "
      points="8.3 7.7 9.7 6.3 15.7 12.3 9.7 18.3 8.3 16.9 12.9 12.3"
    />
  </Base>
)

export default ChevronDown
